export const dateFormat = 'YYYY-MM-DD';

export const longDateFormat = 'YYYY-MM-DD HH:mm:ss Z';
